import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IProjectList {
	projectList: any[];
}

const initialState: IProjectList = {
    projectList: []
};

export const projectListSlice = createSlice({
	name: "projectList",
	initialState,
	reducers: {
        updateProjectList: (state, actions: PayloadAction<any>) => {
			state.projectList = actions.payload;
		},
	},
});

export const { 
    updateProjectList
 } = projectListSlice.actions;

export default projectListSlice.reducer;
